import Axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import { Endpoints } from 'utils/endpoints';
import type { AuthTokenApiResponse } from './interfaces';

const defaultAxiosClient: AxiosRequestConfig = {
  baseURL: globalThis.env.VITE_API_ENDPOINT,
  withCredentials: true,
};

export const generateNewAccessToken = async (): Promise<AuthTokenApiResponse> => {
  const axios = Axios.create(defaultAxiosClient);

  const response = await axios.post<AuthTokenApiResponse>(Endpoints.refreshToken);
  return response.data;
};

export const isTransientRefreshFailure = (e: unknown): boolean => {
  if (!Axios.isAxiosError(e)) return false;
  if (!e.response) return true;
  if (e.response.status >= 500) return true;
  return false;
};
